(() => {
  const root = document.querySelector('[data-paper-pdp-root]');
  if (!root) return;
  const params = new URLSearchParams(location.search);
  const handles = { 'custom-photocards': 'photocard', 'custom-postcards': 'postcard' };
  const handle = root.dataset.nativeProduct || params.get('zz_product');
  if (!Object.hasOwn(handles, handle)) return;
  const config = JSON.parse(document.getElementById('paper-pdp-theme-config').textContent);
  const previewThemeId = params.get('preview_theme_id') || (window.Shopify?.theme?.role !== 'main' ? config.previewThemeId : null);
  const locale = params.get('zz_lang') === 'zh' ? 'zh' : 'en';
  const route = (target) => {
    const url = new URL('/products/' + target, location.origin);
    if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
    if (locale === 'zh') url.searchParams.set('zz_lang', 'zh');
    return url.href;
  };
  const productPage = new URL(location.href);
  productPage.hash = '';
  if (previewThemeId) productPage.searchParams.set('preview_theme_id', previewThemeId);
  const category = new URL('/collections/all?zz_category=paper', location.origin);
  if (previewThemeId) category.searchParams.set('preview_theme_id', previewThemeId);
  if (locale === 'zh') category.searchParams.set('zz_lang', 'zh');
  const editor = new URL('/products/' + handle, location.origin);
  editor.searchParams.set('view', 'paper-editor');
  if (previewThemeId) editor.searchParams.set('preview_theme_id', previewThemeId);
  window.ZekzekPaperPdpContext = {
    productId: handles[handle], locale, assets: config.assets, editorHref: editor.href,
    productPage: productPage.href, collectionHref: category.href,
    otherHref: route(handle === 'custom-photocards' ? 'custom-postcards' : 'custom-photocards')
  };
  document.body.dataset.locale = locale;
  document.body.classList.add('paper-storefront');
  document.documentElement.lang = locale === 'zh' ? 'zh-CN' : 'en';
  const view = document.querySelector('[data-catalog-view]');
  if (view) view.hidden = true;
})();
